import { createRouter, createWebHistory } from "vue-router";
import eventbus from "@eventbus";
import logger from "@helpers/logger";
import { useUserStore } from "@stores/userStore";
import { handleHotUpdate, routes } from "vue-router/auto-routes";

const router = createRouter({
    history: createWebHistory(),
    routes: routes,
});

// This will update routes at runtime without reloading the page
if (import.meta.hot) {
    handleHotUpdate(router);
}

// Auth - Only allow public routes when not logged in.
router.beforeEach(async (to, from, next) => {
    // Check if route exists
    if (!to.matched.length) {
        logger.warn(
            `User tried navigating to (${to.path}) from (${from.path}), which does not excist.`,
        );
        next(false);

        if (to.path.startsWith("/display")) {
            return router.push("/display");
        }

        return router.push("/");
    }

    const userStore = useUserStore();
    const userType = await userStore.getActiveUserType;

    // User type restrictions
    if (to.meta.allowed_user_types?.includes(userType) === false) {
        logger.warn(
            `User type ${userType} tried navigating to '${to.name}' (${to.path}) origin (${from.path}). Only allowed types: ${to.meta.allowed_user_types.join(", ")}.`,
        );
        next(false);

        if (to.path.startsWith("/display")) {
            if (to.path !== "/display") {
                return router.push("/display");
            }
            return;
        }

        return router.push(userType === "guest" ? "/login" : "/");
    }

    return next();
});

// Tab names
router.beforeEach((to) => {
    // Fallback tab name
    let name = "YHub";

    // Set meta label
    if (to.meta.label) {
        name = `${name} - ${to.meta.label}`;
    }

    // Set tab name
    document.title = name;
});

// Breadcrumbs
router.afterEach((to) => {
    // Fallback
    let breadcrumbs = [];

    // Set breadcrumbs
    if (to.meta.breadcrumbs) {
        breadcrumbs = to.meta.breadcrumbs;
    }

    // Send data
    eventbus.emit("breadcrumbs-set", breadcrumbs);
});

// Progress bar
router.beforeEach(() => {
    eventbus.emit("progressbar-visible", false);
});

// Send event for post navigation
router.afterEach(() => {
    eventbus.emit("post-navigation");
});

export { router };
